import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CursorRegular from './cursor-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CursorRegular {...validProps} />;
}

SvgComponent.iconName = 'cursorRegular';

export const CursorRegularIcon = svgIconWrapper(SvgComponent);
